import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ConfService} from '../../conf.service';
import {MatDialog, MatSnackBar} from '@angular/material';
import {AddDialogComponent} from '../../api-new/api-new.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AttributesListComponent} from '../../attributes-list/attributes-list.component';
import {HeadersComponent} from '../../devex/headers/headers.component';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

    category_id: any;
    partner: any;
    account: any;
    items: any;
    data: any;
    executors: any;
    executorscat: any;
    index = [];
    executorscat1: any;
    getResponse: any;
    getRequest: any;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
  constructor(private route: ActivatedRoute, private confPost: ConfService, public dialog: MatDialog, private _service: ConnecttocrudService) { }
  ngOnInit() {
   this.route.queryParams
        .subscribe(params => {
            if (params) {
                this.partner = params.partner;
                this.account = params.partner;
                this.category_id = params.category;
            }
            this.confPost.getData('services', 'services', 'v1', 'serviceCategories', null).subscribe(response => {
                this.data = response;
                for ( let i = 0; i < this.data.length; i++) {
                    if (this.data[i].id === parseInt(this.category_id, 10)) {
                        this.items = this.data[i];
                    }
                }
                this.confPost.getBusinessLogicApisByCategory('services', 'services').subscribe(data => {
                    this.executors = data;
                    this.executorscat = [];
                    for (let i = 0 ; i < this.executors.length; i++) {
                        if (this.executors[i].category === this.items.name) {
                            this.executorscat.push(this.executors[i].executors);
                        }
                    }
                    this.executorscat1 = [];
                    this.executorscat1 = JSON.parse(JSON.stringify(this.executorscat));
                    let temp = [];
                    let flag: boolean;
                    for (let k = 0; k < this.executorscat[0].length; k++) {
                        flag = false;
                        for (let i = 0; i < this.items.apisList.length; i++) {
                            if (this.executorscat[0][k].id === this.items.apisList[i]) {
                                flag = true;
                            }
                        }
                        if (flag === false) {
                            temp.push(this.executorscat[0][k]);
                        }
                    }
                    this.executorscat[0] = temp;
                    // localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
                });
            });
        });
    }
    saveExecutorDescription(attr, value) {
        this.items.summary = value;
        this.confPost.patchEntityData('services', 'services', 'v1', 'serviceCategories', this.items.id, this.items).subscribe(  success => {});
    }
    executeApi(type, url, headers, parameters, authModel, requestBody1, prerequisites) {
        const requestBody = this.headerChild.getRequestBody();
        const payload = {
            'executor_name': '',
            'executor_type': 'API',
            'executor_method_type': type,
            'apiUrl': url,
            'dataroot': null,
            'queryParams': parameters,
            'headers': headers,
            'requestBody': this.headerChild.getRequestBody(),
            'prerequisites': prerequisites
        };
        payload['authModel'] = this.headerChild.authModel1.getAuthModel();
        // if (this.authModel1) {
        //   payload['authModel'] = this.authModel1.authModel;
        // } else {
        //   payload['authModel'] = authModel;
        // }

        this._service.executeApi(payload).subscribe(response => {
            this.getResponse = response;
            this.getRequest = payload;
        });
    }
    stringifyjson(val) {
        return JSON.stringify(val);
    }
  openAddDialog() {
      const dialogRef = this.dialog.open(AddCatComponent, {
          width: '30%',
          data: this.executorscat
      });
      dialogRef.afterClosed().subscribe(result => {
          if (result !== undefined) {
              if (result.length > 0) {
                  for ( let i = 0; i < result.length; i++ ) {
                      this.items.apisList.push(result[i]);
                  }
                  this.confPost.patchEntityData('services', 'services', 'v1', 'serviceCategories', this.items.id, this.items).subscribe(  success => {
                      alert('Succesfully Updated');
                  }, error => {
                      alert('Some error occured. Please try again later');
                  });
              }
          }
      });
  }

}

@Component({
    selector: 'app-add-cat',
    templateUrl: './add-cat.component.html',
    styleUrls: ['./add-cat.component.scss']
})
export class AddCatComponent implements OnInit {
    checked = [];
    constructor (public platform: LeftpanelComponent,
                 public dialogRef: MatDialogRef <AddCatComponent>,
                 @Inject(MAT_DIALOG_DATA) public data: any) { }
    ngOnInit(): void {
    }
    setAll(completed: boolean, id: number) {
        if (completed) {
            this.checked.push( id );
        } else {
            const index: number = this.checked.indexOf(id);
            if (index !== -1) {
                this.checked.splice(index, 1);
            }
        }
    }
    stringifyjson(val) {
        return JSON.stringify(val);
    }
    Save() {
        this.dialogRef.close(this.checked);
    }
}
